// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap___2yXS8","container":"container___3T3Jx","card":"card___2h6Ch","iconWrap":"iconWrap___2j8fv","icon":"icon___3WpAi","text":"text___3A1hY"};